// Author Liang Gang Qiang
// Date 2021-10-20 11:55:13

class MintalMesPrdManagePlan {
constructor({
        id = null,
        title = '',
        category = '',
        contentCategory = '',
        attachments = '',
        remark = '',
        attachmentsList = ''}
= {}) {
    this.id = id;
    this.title = title;
    this.category = category;
    this.contentCategory = contentCategory;
    this.attachments = attachments;
    this.remark = remark;
    this.attachmentsList = attachmentsList;
}
}

function newEntity() {
return new MintalMesPrdManagePlan();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'title',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.grid.title',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdTime',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.grid.createdTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'createdByName',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.grid.createdByName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'category',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.grid.category',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '月度' },
                            { value: '2', text: '年度' }
            ]
        }
        },
        {
        key: 'contentCategory',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.grid.contentCategory',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '经营计划指标' },
                            { value: '2', text: '技改大修任务' },
                            { value: '3', text: '大宗物料采购计划' },
                            { value: '4', text: '其他经营建设事项' }
            ]
        }
        },
        {
        key: 'attachmentsList',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.grid.attachmentsList',
        sortable: true,
            // isDetail: true,
        form: {
        type: 'emAttachment'
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    titleFilter : "",
    categoryFilter : "",
    contentCategoryFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'titleFilter',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.filter.title',
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'categoryFilter',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.filter.category',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '月度' },
                { value: '2', text: '年度' }
            ]
        }
        },
        {
        key: 'contentCategoryFilter',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.filter.contentCategory',
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
         ,options: [
                { value: '1', text: '经营计划指标' },
                { value: '2', text: '技改大修任务' },
                { value: '3', text: '大宗物料采购计划' },
                { value: '4', text: '其他经营建设事项' }
            ]
        }
        }
];


    const entityFormConfigs = [
        {
        key: 'title',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.entity.title',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
                }
        },
        {
        key: 'category',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.entity.category',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '月度' },
                { value: '2', text: '年度' }
            ]
        }
        },
        {
        key: 'contentCategory',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.entity.contentCategory',
        sortable: true,
        disabled: false,
        form: {
        type: 'select'
            ,showLabelSelectOne: true
        ,options: [
                { value: '1', text: '经营计划指标' },
                { value: '2', text: '技改大修任务' },
                { value: '3', text: '大宗物料采购计划' },
                { value: '4', text: '其他经营建设事项' }
            ]
        }
        },
        {
        key: 'remark',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        },
        {
        key: 'attachmentsList',
        label: 'label.mintal.prd.mintalMesPrdManagePlan.entity.attachments',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment'
            ,correspondingField: 'attachments'
                }
        }
]

export {MintalMesPrdManagePlan, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
